<p class="font-medium text-xs leading-normal text-[#C10007] mt-0.5 h-[1px]" [ngClass]="height">
  {{error}}
</p>
